/**
 * 移动设备检测
 * @returns {boolean}
 */
export const mobilecheck = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(navigator.userAgent) ||
    window.screen.width < 500
}

export const isApp = () => {
  return getUrlParam('platform') || !!window.viewData
}

export const isWeixin = () => {
  return /MicroMessenger/i.test(navigator.userAgent)
}
function parseUrl (url) {
  if (url.startsWith('//')) {
    url = location.protocol + url
  }
  return new window.URL(url)
}

function getUrlParam (name, url = window.location.href) {
  return parseUrl(url).searchParams.get(name)
}

export const getAppType = () => {
  return parseInt(getUrlParam('platform')) || 0
}
/**
 * 判断是否是谷歌
 */
export const isChrome = () => {
  return /Chrome/.test(navigator.userAgent)
}
/**
 * 判断是否是Safari
 */
export const isSafari = () => {
  return (
    /Safari/i.test(window.navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent)
  )
}
